import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { useState, useEffect } from 'react';
import useAxiosPrivate from "../hooks/useAxiosPrivate";
const usoCfdiOptions = [
  { label: 'D10 - Pagos por servicios educativos (colegiaturas)', value: 'D10' },
  { label: 'G03 - Gastos en general', value: 'G03' },
  { label: 'S01 - Sin efectos fiscales', value: 'S01' }
];

const regimenFiscalOptions = [
{ label: '601 - General de Ley Personas Morales', value: '601' },
{ label: '603 - Personas Morales con Fines no Lucrativos', value: '603' },
{ label: '605 - Sueldos y Salarios e Ingresos Asimilados a Salarios', value: '605' },
{ label: '606 - Arrendamiento', value: '606' },
{ label: '607 - Régimen de Enajenación o Adquisición de Bienes', value: '607' },
{ label: '608 - Demás ingresos', value: '608' },
{ label: '610 - Residentes en el Extranjero sin Establecimiento Permanente en México', value: '610' },
{ label: '611 - Ingresos por Dividendos (socios y accionistas)', value: '611' },
{ label: '612 - Personas Físicas con Actividades Empresariales y Profesionales', value: '612' },
{ label: '614 - Ingresos por intereses', value: '614' },
{ label: '615 - Régimen de los ingresos por obtención de premios', value: '615' },
{ label: '616 - Sin obligaciones fiscales', value: '616' },
{ label: '620 - Sociedades Cooperativas de Producción que optan por diferir sus ingresos', value: '620' },
{ label: '621 - Incorporación Fiscal', value: '621' },
{ label: '622 - Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras', value: '622' },
{ label: '623 - Opcional para Grupos de Sociedades', value: '623' },
{ label: '624 - Coordinados', value: '624' },
{ label: '625 - Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas', value: '625' },
{ label: '626 - Régimen Simplificado de Confianza', value: '626' },
];

const FacturacionDialog = ({ visible, setVisible, matricula }) => {
  const [form, setForm] = useState({
    rfc: '',
    nombre: '',
    cp: '',
    email: '',
    regimenFiscal: '',
    usoCfdi: ''
  });

  const axiosPrivate = useAxiosPrivate();
  const handleChange = (e, field) => {
    setForm({ ...form, [field]: e.target ? e.target.value : e.value });
  };

  const guardar = async () => {
    if (!form.rfc || !form.nombre || !form.cp || !form.email || !form.regimenFiscal || !form.usoCfdi) {
      alert('Todos los campos son obligatorios');
      return;
    }

    console.log('Datos facturación:', form);
    //facturacion/save

        try {   
                const response = await axiosPrivate.post("CEUM/facturacion/save", JSON.stringify({
                    matricula,
                    ...form
                    }) );
                console.log("Respuesta API:", response.data);
    } catch (error) {
        console.error("Error al guardar datos de facturación:", error);
    }
    setVisible(false);
  };
useEffect(() => {
  const fetchData = async () => {
    if (!matricula) return;

    const res = await axiosPrivate.get(`/CEUM/facturacion/${matricula}`);
    console.log("Respuesta API facturación:", res.data);
    const data = await res.data;

    if (data) {
      setForm({
        rfc: data.rfc,
        nombre: data.nombre,
        cp: data.cp,
        email: data.email,
        regimenFiscal: data.regimen_fiscal,
        usoCfdi: data.uso_cfdi
      });
    } else {
      setForm({
        rfc: '',
        nombre: '',
        cp: '',
        email: '',
        regimenFiscal: '',
        usoCfdi: ''
      });
    }
  };

  if (visible) fetchData();

}, [visible, matricula]);
  return (
    <Dialog
      header="Datos de Facturación"
      visible={visible}
      style={{ width: '40vw' }}
      onHide={() => {
    setVisible(false);
    setForm({
      rfc: '',
      nombre: '',
      cp: '',
      email: '',
      regimenFiscal: '',
      usoCfdi: ''
    });
  }}
      modal
    >
      <div className="p-fluid grid">

        <div className="field col-12">
          <label>RFC</label>
          <InputText
            value={form.rfc}
            onChange={(e) => handleChange(e, 'rfc')}
            placeholder="RFC del receptor"
          />
        </div>

        <div className="field col-12">
          <label>Nombre / Razón Social</label>
          <InputText
            value={form.nombre}
            onChange={(e) => handleChange(e, 'nombre')}
          />
        </div>

        <div className="field col-12 md:col-6">
          <label>Código Postal (Domicilio Fiscal)</label>
          <InputText
            value={form.cp}
            onChange={(e) => handleChange(e, 'cp')}
          />
        </div>
        <div className="field col-12 md:col-6">
          <label>Regimen Fiscal</label>
          <Dropdown
            value={form.regimenFiscal}
            options={regimenFiscalOptions}
            onChange={(e) => handleChange(e, 'regimenFiscal')}
            placeholder="Selecciona regimen fiscal"
          />
        </div>

        <div className="field col-12 md:col-6">
          <label>Uso del CFDI</label>
          <Dropdown
            value={form.usoCfdi}
            options={usoCfdiOptions}
            onChange={(e) => handleChange(e, 'usoCfdi')}
            placeholder="Selecciona uso CFDI"
          />
        </div>

        <div className="field col-12">
          <label>Correo Electrónico</label>
          <InputText
            value={form.email}
            onChange={(e) => handleChange(e, 'email')}
          />
        </div>

      </div>

      <div className="flex justify-content-end gap-2 mt-3">
        <Button
          label="Cancelar"
          className="p-button-text"
          onClick={() => setVisible(false)}
        />
        <Button
          label="Guardar"
          icon="pi pi-check"
          onClick={guardar}
        />
      </div>
    </Dialog>
  );
};

export default FacturacionDialog;